import React, { useState, useEffect } from 'react';
import { Redirect, Link } from 'react-router-dom';

import { reqGET,
    set_language,
	content_language,
} from '../../../Utils';

import { api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from './../../../UseToken';

import Loader from '../../Loader/Loader';

import { language } from './Language';

export default function View(props) {

    const [dados, set_dados] = useState(data_interface);

    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);

    const [lang, set_lang] = useState('pt');
    const [, set_lang_id] = useState('1');

    // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {
        await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
            .then(res => set_dados(res.data[0]))
            .catch(() => 404
                //  TODO: ENVIAR PÁGINA 404
                //  alert(error)); 
            );
    }

    useEffect(() => {

        if(localStorage.getItem('lang') === undefined  || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_language('pt')
            set_lang_id('1')

        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if(el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id']).then(() => setLoading(false))
        }
        else {
            setLoading(false);
            setRedirect(true);
        }

    }, [props]);



    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?
            
            <Loader />

            :
            
            <main>

                <div className={`dash-cards-2 header`}>
                    {console.log('DADOS PERFIL FORMADOR ---------->', dados)}
                    <h2 className="dash-title">{language[lang].entity}</h2>
                    <span>
                        <Link to={{ pathname: endpoints.list }}  >
							{language[lang].entity}
						</Link>
						&nbsp;&#47;&nbsp;
                        {dados.info.name}&nbsp;{dados.info.surname}
                    </span>
                </div>

                <div className={`dash-cards-2 body`}>
                    <div className='container'>
                        <div className='row'>
                            <h2 className="dash-title border-bottom">{language[lang].profile}</h2>
                            {
                                dados.info['files'] !== undefined ?
                                    dados.info.files.map((el_f, k_f) => {
                                        if(el_f.type === 'profile-picture') {
                                            return (
                                                <div key={k_f} className='col-12 mt-3'>
													<div className='row'>
                                                        <div className='col-12 col-sm-3 col-md-2'>
                                                            <label className="col-form-label fw-bold fs-6">{language[lang].image_profile}</label>
                                                            <img className='img-fluid' alt={el_f.name} title={el_f.name} src={el_f.link} />
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        }
                                        else {
                                            return null
                                        }
                                    })
                                :
                                    null
                            }
                            <div className='col-12 col-md-4 my-3'>
                                <label className="col-form-label fs-6 fw-bold">{language[lang].name}&nbsp;({language[lang].profile})</label>
                                <p>{dados.info.name}</p>
                            </div>
                            <div className='col-12 col-md-4 my-3'>
                                <label className="col-form-label fs-6 fw-bold">{language[lang].surname}&nbsp;({language[lang].profile})</label>
                                <p>{dados.info.surname}</p>
                            </div>
                            { 
                                dados.info.name_full !== '' ? 
                                    <div className='col-12 col-md-4 my-3'>
                                        <label className="col-form-label fs-6 fw-bold">{language[lang].name_full}</label>
                                        <p>{dados.info.name_full}</p>
                                    </div>
                                : null
                            }
                            <div className='col-12 col-md-4 my-3'>
                                <label className="col-form-label fs-6 fw-bold">{language[lang].username_email}</label>
                                <p>{dados.info.username}</p>
                            </div>
                            <div className='col-12 col-md-4 my-3'>
                                <label className="col-form-label fs-6 fw-bold">{language[lang].contact_email}</label>
                                <p>{dados.info.email}</p>
                            </div>
                            { 
                                dados.info.phone !== '' ?
                                    <div className='col-12 col-md-4 my-3'>
                                        <label className="col-form-label fs-6 fw-bold">{language[lang].phone_number}</label>
                                        <p>{dados.info.phone}</p>
                                    </div>
                                : null
                            }
                            { 
                                dados.addresses[0].address !== '' ? 
                                    <div className='col-12 col-md-4 my-3'>
                                        <label className="col-form-label fs-6 fw-bold">{language[lang].address}</label>
                                        <p>{dados.addresses[0].address}</p>
                                    </div>
                                : null
                            }

                            { 
                                dados.addresses[0].postal_code !== '' ?
                                    <div className='col-12 col-md-3 my-3'>
                                        <label className="col-form-label fs-6 fw-bold">{language[lang].postal_code}</label>
                                        <p>{dados.addresses[0].postal_code}</p>
                                    </div>
                                : null
                            }

                            { 
                                dados.addresses[0].location !== '' ?
                                    <div className='col-12 col-md-3 my-3'>
                                        <label className="col-form-label fs-6 fw-bold">{language[lang].location}</label>
                                        <p>{dados.addresses[0].location}</p>
                                    </div>
                                : null
                            }

                            { 
                                dados.addresses[0].village !== '' ?
                                    <div className='col-12 col-md-3 my-3'>
                                        <label className="col-form-label fs-6 fw-bold">{language[lang].village}</label>
                                        <p>{dados.addresses[0].village}</p>
                                    </div>
                                : null
                            }

                            { 
                                dados.addresses[0].municipality !== '' ?
                                    <div className='col-12 col-md-3 my-3'>
                                        <label className="col-form-label fs-6 fw-bold">{language[lang].municipality}</label>
                                        <p>{dados.addresses[0].municipality}</p>
                                    </div>
                                : null
                            }

                            { 
                                dados.info.date_birth !== '' ?
                                    <div className='col-12 col-md-3 my-3'>
                                        <label className="col-form-label fs-6 fw-bold">{language[lang].date_birth}</label>
                                        <p>{dados.info.date_birth}</p>
                                    </div>
                                : null
                            }

                            { 
                                dados.info.age !== '' ?
                                    <div className='col-12 col-md-3 my-3'>
                                        <label className="col-form-label fs-6 fw-bold">{language[lang].age}</label>
                                        <p>{dados.info.age}</p>
                                    </div>
                                : null
                            }

                            { 
                                dados.addresses[0].place_birth !== '' ?
                                    <div className='col-12 col-md-3 my-3'>
                                        <label className="col-form-label fs-6 fw-bold">{language[lang].place_birth}</label>
                                        <p>{dados.addresses[0].place_birth}</p>
                                    </div>
                                : null
                            }

                            { 
                                dados.info.id_type !== '' ?
                                    <div className='col-12 col-md-3 my-3'>
                                        <label className="col-form-label fs-6 fw-bold">{language[lang].id_type}</label>
                                        <p>{language[lang][dados.info.id_type]}</p>
                                    </div>
                                : null
                            }

                            { 
                                dados.info.id_number !== '' ?
                                    <div className='col-12 col-md-3 my-3'>
                                        <label className="col-form-label fs-6 fw-bold">{language[lang].id_number}</label>
                                        <p>{dados.info.id_number}</p>
                                    </div>
                                : null
                            }

                            { 
                                dados.info.id_validity !== '' ?
                                    <div className='col-12 col-md-3 my-3'>
                                        <label className="col-form-label fs-6 fw-bold">{language[lang].id_validity}</label>
                                        <p>{dados.info.id_validity}</p>
                                    </div>
                                : null
                            }

                            { 
                                dados.info.nif !== '' ?
                                    <div className='col-12 col-md-3 my-3'>
                                        <label className="col-form-label fs-6 fw-bold">NIF</label>
                                        <p>{dados.info.nif}</p>
                                    </div>
                                : null
                            }

                        </div>
                    </div>

                </div>

                <div className={'dash-cards-2 footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">

                            <ul className="navbar-nav float-left"></ul>

                            <ul className="navbar-nav float-right">

                                { props.location.state.backup_operation !== undefined ? (
									<li className="nav-item">
										<Link className="nav-link btn-cancel" to={{ pathname: '/formation_content_gest', state: { item: {id: props.location.state.formation_id}, operation: 'edit' } }}  >
                                            <img alt='' src={'./img/seta_2.svg'} />
											<span>{language[lang].back}</span>
										</Link>
									</li>
								) : 
                                    <li className="nav-item">
                                        <Link className="nav-link btn-cancel" to={{ pathname: (endpoints.list) }} replace>
                                            <img alt='' src={'./img/seta_2.svg'} />
                                            <span>{language[lang].back}</span>
                                        </Link>
                                    </li>
                                }
                            </ul>

                        </div>
                    </nav>
                </div>
                
            </main>
}